import { TrainingAPI } from "../../api/TrainingAPI";
const trainingAPI = new TrainingAPI();
import { message } from "antd";

export const STATUS_TRACKER_SET_CELL_LOADING = "[STATUS_TRACKER]_SET_CELL_LOADING";
export const STATUS_TRACKER_SET_DATA = "[STATUS_TRACKER]_SET_DATA";
export const STATUS_TRACKER_FLAG_METADATA = "[STATUS_TRACKER]_SET_FLAG_METADATA";
export const STATUS_TRACKER_SET_FILTER = "[STATUS_TRACKER]_SET_FILTER";
export const STATUS_TRACKER_SET_CUSTOM_STATUS_DATA = "[STATUS_TRACKER]_SET_CUSTOM_STATUS_DATA";
export const STATUS_TRACKER_SET_AVAILABLE_STATUS_DATA = "[STATUS_TRACKER]_SET_AVAILABLE_STATUS_DATA";
export const STATUS_TRACKER_SET_MODAL_LOADING = "[STATUS_TRACKER]_SET_MODAL_LOADING";

export const setStatusTrackerData = (data) => {
  return {
    type: STATUS_TRACKER_SET_DATA,
    data,
  };
};

export const setStatusTrackerFlagMetadata = (data) => {
  return {
    type: STATUS_TRACKER_FLAG_METADATA,
    data,
  };
};

export const setStatusTrackerCellLoading = (data) => {
  return {
    type: STATUS_TRACKER_SET_CELL_LOADING,
    data,
  };
};

export const setFilter = (data) => {
  return {
    type: STATUS_TRACKER_SET_FILTER,
    data,
  };
};

export const setCustomStatusData = (data) => {
  return {
    type: STATUS_TRACKER_SET_CUSTOM_STATUS_DATA,
    data,
  };
};

export const setAvailableStatuses = (data) => {
  return {
    type: STATUS_TRACKER_SET_AVAILABLE_STATUS_DATA,
    data,
  };
};

export const setModalLoding = (data) => {
  return {
    type: STATUS_TRACKER_SET_MODAL_LOADING,
    data,
  };
};

export const getStatusTrackerData = (cellKeyObj, date) => {
  return async (dispatch, getState) => {
    dispatch(setStatusTrackerCellLoading(cellKeyObj));
    try {
      const data = await trainingAPI.getStatusTrackerData(date);
      dispatch(setStatusTrackerData(data));
    } catch (e) {
      console.error(e);
    }
    dispatch(setStatusTrackerCellLoading(Object.keys(cellKeyObj).reduce((cell, key) => {
      cell[key] = false;
      return cell;
    }, {})));
  };
};

export const getStatusTrackerFlagMetadata = (year, month) => {
  return async (dispatch, getState) => {
    try {
      const data = await trainingAPI.getStatusTrackerFlagMetadata(year, month);
      dispatch(setStatusTrackerFlagMetadata(data));
    }
    catch (e) {
      console.error(e);
    }
  };
};

export const createCustomStatus = (uniquekey, params) => {
  const modalLoadingKey = `${uniquekey}Modal`
  return async (dispatch, getState) => {
    dispatch(setModalLoding({[modalLoadingKey]: true}));
    try {
      const data = await trainingAPI.createCustomStatus(params);
      dispatch(setAvailableStatuses(data));
    } catch (e) {
      console.error(e);
    }
    dispatch(setModalLoding({[modalLoadingKey]: false}));
  };
};

export const updateCustomStatus = (uniquekey, params, statusMapping) => {
  const modalLoadingKey = `${uniquekey}Modal`
  return async (dispatch, getState) => {
    dispatch(setModalLoding({[modalLoadingKey]: true}));
    try {
      const data = await trainingAPI.updateCustomStatus(params);
      const updatedStatus = data.filter(stat => stat.id === params.status_id || stat.status_id === params.status_id)[0];
      for (let player_id in statusMapping) {
        for (let i = 0; i < statusMapping[player_id].length; i++) {
          const date = statusMapping[player_id][i];
          dispatch(setCustomStatusData([`${player_id}_${date}`, updatedStatus]));
        }
      }
      dispatch(setAvailableStatuses(data));
    } catch (e) {
      console.error(e);
    }
    dispatch(setModalLoding({[modalLoadingKey]: false}));
  };
};

export const deleteCustomStatus = (uniquekey, params, statusMapping) => {
  const modalLoadingKey = `${uniquekey}Modal`
  return async (dispatch, getState) => {
    dispatch(setModalLoding({[modalLoadingKey]: true}));
    try {
      const data = await trainingAPI.deleteCustomStatus(params);
      const fullStatus = data.filter(stat => stat.name === "Full")[0];
      for (let player_id in statusMapping) {
        for (let i = 0; i < statusMapping[player_id].length; i++) {
          const date = statusMapping[player_id][i];
          dispatch(setCustomStatusData([`${player_id}_${date}`, fullStatus]));
        }
      }
      dispatch(setAvailableStatuses(data));
    } catch (e) {
      console.error(e);
    }
    dispatch(setModalLoding({[modalLoadingKey]: false}));
  };
};

export const getAvailableStatuses = (start_date, end_date) => {
  return async (dispatch, getState) => {
    try {
      const data = await trainingAPI.getAvailableStatuses(start_date, end_date);
      dispatch(setAvailableStatuses(data));
    } catch (e) {
      console.error(e);
    }
  };
};

export const selectPlayerStatus = (uniquekey, params) => {
  const modalLoadingKey = `${uniquekey}Modal`
  return async (dispatch, getState) => {
    dispatch(setModalLoding({[modalLoadingKey]: true}));
    try {
      const data = await trainingAPI.selectPlayerStatus(params);
      dispatch(setCustomStatusData([uniquekey, data]));
      dispatch(getAvailableStatuses());
    } catch (e) {
      console.error(e);
    }
    dispatch(setModalLoding({[modalLoadingKey]: false}));
  };
};

export const deletePlayerStatus = (uniquekey, params) => {
  const modalLoadingKey = `${uniquekey}Modal`
  return async (dispatch, getState) => {
    dispatch(setModalLoding({[modalLoadingKey]: true}));
    try {
      const data = await trainingAPI.deletePlayerStatus(params);
      dispatch(setCustomStatusData([uniquekey, data]));
      dispatch(getAvailableStatuses());
    } catch (e) {
      console.error(e);
    }
    dispatch(setModalLoding({[modalLoadingKey]: false}));
  };
};